import { DateTime } from 'luxon'
export * from './formDate'

export const dateFormater = (date: string, format: string = 'dd/MM'): string => {
  const luxonDate = DateTime.fromISO(date)

  if (!luxonDate.isValid) {
    return '-'
  }

  return luxonDate.toFormat(format)
}

export const isStartDateGreaterThanCurrentDate = (startDate: string): boolean => {
  const formattedStartDate = DateTime.fromISO(startDate)
  const today = DateTime.now()

  return today < formattedStartDate
}
export const isCurrentDateBetweenDates = (startDate: string, endDate: string): boolean => {
  const formattedStartDate = DateTime.fromISO(startDate).startOf('day')
  const formattedEndDate = DateTime.fromISO(endDate).startOf('day')
  const today = DateTime.now().startOf('day')

  return formattedStartDate <= today && today <= formattedEndDate
}

export const isCurrentDateBiggerThanDeadline = (deadline: string): boolean => {
  const deadlineDay = DateTime.fromISO(deadline).startOf('day')
  const today = DateTime.now().startOf('day')

  return today > deadlineDay
}

export const formatDateToDayYear = (date: string): string => {
  return DateTime.fromISO(date).setLocale('pt-BR').toFormat("dd 'de' LLLL")
}

export const getUnnabreviatedDate = (date: string): string => {
  return DateTime.fromISO(date).setLocale('pt').toLocaleString(DateTime.DATE_FULL)
}
